import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiFilter, FiCalendar, FiUser, FiHome, FiRefreshCw } = FiIcons;

const PaymentReportFilters = ({ onFilterChange, properties, tenants }) => {
  const [filters, setFilters] = useState({
    startDate: '',
    endDate: '',
    propertyId: 'all',
    tenantId: 'all',
    status: 'all'
  });

  const handleChange = (key, value) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    onFilterChange(newFilters);
  };

  const handleReset = () => {
    const reset = { startDate: '', endDate: '', propertyId: 'all', tenantId: 'all', status: 'all' };
    setFilters(reset);
    onFilterChange(reset);
  };

  return (
    <div className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm space-y-4">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-xs font-black text-gray-400 uppercase tracking-widest flex items-center gap-2">
          <SafeIcon icon={FiFilter} className="text-indigo-500" /> Report Parameters
        </h3>
        <button onClick={handleReset} className="text-[10px] font-black text-red-500 uppercase tracking-widest flex items-center gap-1 hover:text-red-600 transition-colors">
          <SafeIcon icon={FiRefreshCw} size={12} /> Reset
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        <div className="space-y-1.5">
          <label className="text-[9px] font-black text-gray-400 uppercase ml-1">Date From</label>
          <div className="relative">
            <SafeIcon icon={FiCalendar} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={14} />
            <input type="date" value={filters.startDate} onChange={(e) => handleChange('startDate', e.target.value)} className="w-full pl-9 p-2.5 bg-gray-50 border border-transparent rounded-xl text-xs font-bold outline-none focus:ring-2 focus:ring-indigo-500" />
          </div>
        </div>

        <div className="space-y-1.5">
          <label className="text-[9px] font-black text-gray-400 uppercase ml-1">Date To</label>
          <div className="relative">
            <SafeIcon icon={FiCalendar} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={14} />
            <input type="date" value={filters.endDate} onChange={(e) => handleChange('endDate', e.target.value)} className="w-full pl-9 p-2.5 bg-gray-50 border border-transparent rounded-xl text-xs font-bold outline-none focus:ring-2 focus:ring-indigo-500" />
          </div>
        </div>

        <div className="space-y-1.5">
          <label className="text-[9px] font-black text-gray-400 uppercase ml-1">Property</label>
          <div className="relative">
            <SafeIcon icon={FiHome} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={14} />
            <select value={filters.propertyId} onChange={(e) => handleChange('propertyId', e.target.value)} className="w-full pl-9 p-2.5 bg-gray-50 border border-transparent rounded-xl text-xs font-bold outline-none appearance-none focus:ring-2 focus:ring-indigo-500">
              <option value="all">All Properties</option>
              {properties.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
          </div>
        </div>

        <div className="space-y-1.5">
          <label className="text-[9px] font-black text-gray-400 uppercase ml-1">Tenant</label>
          <div className="relative">
            <SafeIcon icon={FiUser} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={14} />
            <select value={filters.tenantId} onChange={(e) => handleChange('tenantId', e.target.value)} className="w-full pl-9 p-2.5 bg-gray-50 border border-transparent rounded-xl text-xs font-bold outline-none appearance-none focus:ring-2 focus:ring-indigo-500">
              <option value="all">All Tenants</option>
              {tenants.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
            </select>
          </div>
        </div>

        <div className="space-y-1.5">
          <label className="text-[9px] font-black text-gray-400 uppercase ml-1">Payment Status</label>
          <select value={filters.status} onChange={(e) => handleChange('status', e.target.value)} className="w-full p-2.5 bg-gray-50 border border-transparent rounded-xl text-xs font-bold outline-none focus:ring-2 focus:ring-indigo-500">
            <option value="all">All Statuses</option>
            <option value="Paid">Paid</option>
            <option value="Overdue">Overdue</option>
            <option value="Pending">Pending</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default PaymentReportFilters;